import { render, staticRenderFns } from "./RestrictArea.vue?vue&type=template&id=32e1e08d&"
import script from "./RestrictArea.vue?vue&type=script&lang=js&"
export * from "./RestrictArea.vue?vue&type=script&lang=js&"
import style0 from "./RestrictArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports